import axios from 'axios';
import { message } from 'antd';
import localStorage from '../../../utils/localStorage';
import {
  API_AUTH,
  API_FRACAS,
  API_RUBUSMASTERS,
  //   API_DEVICEPARAMETER,
  //   API_DEVICETYPE,
  API_HIERARCHYMODULE,
  //   API_TRENDS,
  //   BOOKMARK,
  API_DEVICE,
  API_FRACAS_MULTIPLE
  //   API_ASSET
} from '../../../commons/api';
export async function getUserHeirarchyData() {
  const siteId = localStorage.get('currentSite');
  const token = localStorage.get('accessToken');

  let Authorization = 'Bearer ' + token;
  const deciceListApi = {
    method: 'GET',
    url: `${API_AUTH.ME}?SiteId=${siteId}&menuType=Web`,
    headers: {
      Authorization: Authorization
    }
  };
  return axios(deciceListApi)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (
        (err && err.response && err.response.status && err.response.status === 400) ||
        err.response.status === 500
      ) {
        message.info(err && err.response && err.response.data && err.response.data.message);
      }
    });
}
export async function getHierarchyTreeData(value) {
  const token = localStorage.get('accessToken');
  const siteId = localStorage.get('currentSite');
  let Authorization = 'Bearer ' + token;
  const getProcessArea = {
    method: 'GET',
    url: `${API_HIERARCHYMODULE.GetHierarchyLevels}?HierarchyCode=${value}&SiteId=${siteId}`,
    headers: {
      Authorization: Authorization
    }
  };
  return axios(getProcessArea)
    .then((response) => {
      return response.data;
    })
    .catch(() => {
      return [];
    });
}
export async function getDeviceList() {
  const siteId = localStorage.get('currentSite');
  const token = localStorage.get('accessToken');
  var Authorization = 'Bearer ' + token;
  const parameterGroup = {
    method: 'GET',
    url: `${API_DEVICE.GET}?SiteId=${siteId}`,
    headers: {
      Authorization: Authorization
    }
  };
  return axios(parameterGroup)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      if (
        (err && err.response && err.response.status && err.response.status === 400) ||
        (err && err.response && err.response.status && err.response.status === 500)
      ) {
        message.info(err.response.data.message);
        return [];
      }
    });
}
export async function submitReport(data) {
  const siteId = localStorage.get('currentSite');
  const token = localStorage.get('accessToken');
  var Authorization = 'Bearer ' + token;
  const parameterGroup = {
    method: 'POST',
    url: `${API_FRACAS.ReportingCreate}?SiteId=${siteId}`,
    headers: {
      Authorization: Authorization
    },
    data
  };

  return axios(parameterGroup)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      if (
        (err && err.response && err.response.status && err.response.status === 400) ||
        err.response.status === 500
      ) {
        message.info(err.response.data.message);
      }
    });
}
export async function submitQuestions(data, api) {
  const siteId = localStorage.get('currentSite');
  const token = localStorage.get('accessToken');
  var Authorization = 'Bearer ' + token;
  const parameterGroup = {
    method: 'POST',
    url: `${api}?SiteId=${siteId}`,
    headers: {
      Authorization: Authorization
    },
    data
  };

  return axios(parameterGroup)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      if (
        (err && err.response && err.response.status && err.response.status === 400) ||
        err.response.status === 500
      ) {
        message.info(err.response.data.message);
      }
    });
}

export async function updateQuestions(data, api) {
  const siteId = localStorage.get('currentSite');
  const token = localStorage.get('accessToken');
  var Authorization = 'Bearer ' + token;
  const parameterGroup = {
    method: 'PATCH',
    url: `${api}?SiteId=${siteId}`,
    headers: {
      Authorization: Authorization
    },
    data
  };

  return axios(parameterGroup)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      if (
        (err && err.response && err.response.status && err.response.status === 400) ||
        err.response.status === 500
      ) {
        message.info(err.response.data.message);
      }
    });
}

export async function updateFailure(data) {
  const siteId = localStorage.get('currentSite');
  const token = localStorage.get('accessToken');
  var Authorization = 'Bearer ' + token;
  const parameterGroup = {
    method: 'PATCH',
    url: `${API_FRACAS_MULTIPLE.AnalysisUpdate}?SiteId=${siteId}`,
    headers: {
      Authorization: Authorization
    },
    data
  };

  return axios(parameterGroup)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      if (
        (err && err.response && err.response.status && err.response.status === 400) ||
        err.response.status === 500
      ) {
        message.info(err.response.data.message);
      }
    });
}
export async function updateReport(data) {
  const siteId = localStorage.get('currentSite');
  const token = localStorage.get('accessToken');
  var Authorization = 'Bearer ' + token;
  const parameterGroup = {
    method: 'PATCH',
    url: `${API_FRACAS.ReportingUpdate}?SiteId=${siteId}`,
    headers: {
      Authorization: Authorization
    },
    data
  };

  return axios(parameterGroup)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      if (
        (err && err.response && err.response.status && err.response.status === 400) ||
        err.response.status === 500
      ) {
        message.info(err.response.data.message);
      }
    });
}
export async function createAssignMultiple(data) {
  const siteId = localStorage.get('currentSite');
  const token = localStorage.get('accessToken');
  var Authorization = 'Bearer ' + token;
  const parameterGroup = {
    method: 'POST',
    url: `${API_FRACAS_MULTIPLE.AssignDepartmentCreate}?SiteId=${siteId}`,
    headers: {
      Authorization: Authorization
    },
    data
  };

  return axios(parameterGroup)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      if (
        (err && err.response && err.response.status && err.response.status === 400) ||
        err.response.status === 500
      ) {
        message.info(err.response.data.message);
      }
    });
}

export async function createFailure(data) {
  const siteId = localStorage.get('currentSite');
  const token = localStorage.get('accessToken');
  var Authorization = 'Bearer ' + token;
  const parameterGroup = {
    method: 'POST',
    url: `${API_FRACAS_MULTIPLE.AnalysisCreate}?SiteId=${siteId}`,
    headers: {
      Authorization: Authorization
    },
    data
  };

  return axios(parameterGroup)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      if (
        (err && err.response && err.response.status && err.response.status === 400) ||
        err.response.status === 500
      ) {
        message.info(err.response.data.message);
      }
    });
}
export async function getDeviceTypeList() {
  const siteId = localStorage.get('currentSite');
  const token = localStorage.get('accessToken');
  var Authorization = 'Bearer ' + token;
  const parameterGroup = {
    method: 'GET',
    url: `${API_RUBUSMASTERS.DT_GET}?SiteId=${siteId}&ModuleCode=Metro_RS`,
    headers: {
      Authorization: Authorization
    }
  };
  return axios(parameterGroup)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      if (
        (err && err.response && err.response.status && err.response.status === 400) ||
        (err && err.response && err.response.status && err.response.status === 500)
      ) {
        message.info(err.response.data.message);
        return [];
      }
    });
}
export async function createCorrectiveActionsMultiple(data, status, Id, DepartmentId) {
  const siteId = localStorage.get('currentSite');
  const token = localStorage.get('accessToken');
  var Authorization = 'Bearer ' + token;
  const parameterGroup = {
    method: 'POST',
    url: `${API_FRACAS_MULTIPLE.CorrectiveActionCreate}?SiteId=${siteId}&ReportId=${Id}&Status=${status}&DepartmentId=${DepartmentId}`,
    headers: {
      Authorization: Authorization
    },
    data
  };

  return axios(parameterGroup)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      if (
        (err && err.response && err.response.status && err.response.status === 400) ||
        err.response.status === 500
      ) {
        message.info(err.response.data.message);
      }
    });
}
export async function onReportManagerAction(data) {
  const siteId = localStorage.get('currentSite');
  const token = localStorage.get('accessToken');
  var Authorization = 'Bearer ' + token;
  const parameterGroup = {
    method: 'POST',
    url: `${API_FRACAS_MULTIPLE.UpdateReportStatus}?SiteId=${siteId}`,
    headers: {
      Authorization: Authorization
    },
    data
  };

  return axios(parameterGroup)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      if (
        (err && err.response && err.response.status && err.response.status === 400) ||
        err.response.status === 500
      ) {
        message.info(err.response.data.message);
      }
    });
}

export async function onManagerSubmit(data) {
  const siteId = localStorage.get('currentSite');
  const token = localStorage.get('accessToken');
  var Authorization = 'Bearer ' + token;
  const parameterGroup = {
    method: 'POST',
    url: `${API_FRACAS_MULTIPLE.UpdateStatus}?SiteId=${siteId}`,
    headers: {
      Authorization: Authorization
    },
    data
  };

  return axios(parameterGroup)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      if (
        (err && err.response && err.response.status && err.response.status === 400) ||
        err.response.status === 500
      ) {
        message.info(err.response.data.message);
      }
    });
}
export async function DeleteAttachment(Id) {
  const siteId = localStorage.get('currentSite');
  const accessToken = localStorage.get('accessToken');
  const header = {
    method: 'DELETE',
    url: `${API_FRACAS.DeleteAttachment}?SiteId=${siteId}&Id=${Id}`,
    headers: {
      Authorization: `Bearer ${accessToken}`
    }
  };
  return axios(header)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.log(error);
    });
}
export async function updateCorrectiveActionsMultiple(data, status, ReportId, DepartmentId) {
  const siteId = localStorage.get('currentSite');
  const token = localStorage.get('accessToken');
  var Authorization = 'Bearer ' + token;
  const parameterGroup = {
    method: 'PATCH',
    url: `${API_FRACAS_MULTIPLE.CorrectiveActionUpdate}?SiteId=${siteId}&ReportId=${ReportId}&Status=${status}&DepartmentId=${DepartmentId}`,
    headers: {
      Authorization: Authorization
    },
    data
  };

  return axios(parameterGroup)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      if (
        (err && err.response && err.response.status && err.response.status === 400) ||
        err.response.status === 500
      ) {
        message.info(err.response.data.message);
      }
    });
}
export async function getQuestionsList(FailureType, selectedEquip) {
  const accessToken = localStorage.get('accessToken');
  const siteId = localStorage.get('currentSite');
  const Object = {
    method: 'POST',
    url: `${API_FRACAS.GetQuestions}?SiteId=${siteId}`,
    headers: {
      Authorization: `Bearer ${accessToken}`
    },
    data: {
      Device: selectedEquip,
      failureTypeId: FailureType
    }
  };
  return axios(Object)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      message.info(err && err.response && err.response.data && err.response.data.message);
    });
}
export async function getUsersList(Id) {
  const accessToken = localStorage.get('accessToken');
  const siteId = localStorage.get('currentSite');
  const Object = {
    method: 'POST',
    url: `${API_FRACAS_MULTIPLE.GetByDepartmentRoleUsers}?SiteId=${siteId}`,
    headers: {
      Authorization: `Bearer ${accessToken}`
    },
    data: {
      DepartmentId: [Id],
      RoleType: "Reporting"
    }
  };
  return axios(Object)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      message.info(err && err.response && err.response.data && err.response.data.message);
    });
}
export async function getListMultiple(activeTab) {
  const accessToken = localStorage.get('accessToken');
  const siteId = localStorage.get('currentSite');
  const Object = {
    method: 'GET',
    url: `${API_FRACAS_MULTIPLE.ReportingGet}?SiteId=${siteId}&ScreenName=${activeTab}`,
    headers: {
      Authorization: `Bearer ${accessToken}`
    }
  };
  return axios(Object)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      message.info(err && err.response && err.response.data && err.response.data.message);
    });
}
export async function getDepartmentList() {
  const accessToken = localStorage.get('accessToken');
  const siteId = localStorage.get('currentSite');
  const Object = {
    method: 'GET',
    url: `${API_FRACAS.DepartmentGet}?SiteId=${siteId}`,
    headers: {
      Authorization: `Bearer ${accessToken}`
    }
  };
  return axios(Object)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      message.info(err && err.response && err.response.data && err.response.data.message);
    });
}
export async function getRolesPermissionsList(RoleId) {
  const accessToken = localStorage.get('accessToken');
  const siteId = localStorage.get('currentSite');
  const Object = {
    method: 'POST',
    url: `${API_FRACAS.PermissionGetById}?SiteId=${siteId}`,
    headers: {
      Authorization: `Bearer ${accessToken}`
    },
    data: { RoleId }
  };
  return axios(Object)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      message.info(err && err.response && err.response.data && err.response.data.message);
    });
}
export async function getFailureList() {
  const accessToken = localStorage.get('accessToken');
  const siteId = localStorage.get('currentSite');
  const Object = {
    method: 'GET',
    url: `${API_FRACAS.FailureTypesGet}?SiteId=${siteId}`,
    headers: {
      Authorization: `Bearer ${accessToken}`
    }
  };
  return axios(Object)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      message.info(err && err.response && err.response.data && err.response.data.message);
    });
}
export async function getSeverityList() {
  const accessToken = localStorage.get('accessToken');
  const siteId = localStorage.get('currentSite');
  const Object = {
    method: 'GET',
    url: `${API_FRACAS.SeverityGet}?SiteId=${siteId}`,
    headers: {
      Authorization: `Bearer ${accessToken}`
    }
  };
  return axios(Object)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      message.info(err && err.response && err.response.data && err.response.data.message);
    });
}
export async function getUserList() {
  const token = localStorage.get('accessToken');
  var Authorization = 'Bearer ' + token;
  const siteId = localStorage.get('currentSite');
  let data = {
    url: `${API_FRACAS.UserGet}?SiteId=${siteId}`,
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: Authorization
    }
  };
  return axios(data)
    .then((response) => {
      return response.data;
    })

    .catch(() => { });
}
export async function getStatusList(status) {
  const token = localStorage.get('accessToken');
  var Authorization = 'Bearer ' + token;
  const siteId = localStorage.get('currentSite');
  let data = {
    url: `${API_FRACAS_MULTIPLE.StatusDropdown}?SiteId=${siteId}&Status=${status}`,
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: Authorization
    }
  };
  return axios(data)
    .then((response) => {
      return response.data;
    })

    .catch(() => { });
}
export async function getReportByIdMultiple(Id, screen) {
  const accessToken = localStorage.get('accessToken');
  const siteId = localStorage.get('currentSite');
  const Object = {
    method: 'GET',
    url: `${API_FRACAS_MULTIPLE.ReportingGet}?Id=${Id}&SiteId=${siteId}&ScreenName=${screen}`,
    headers: {
      Authorization: `Bearer ${accessToken}`
    }
  };
  return axios(Object)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      message.info(err && err.response && err.response.data && err.response.data.message);
    });
}
export async function getFailureCodeList(checkedValue) {
  const accessToken = localStorage.get('accessToken');
  const siteId = localStorage.get('currentSite');
  const Object = {
    method: 'GET',
    url: `${API_FRACAS_MULTIPLE.GetParmsByDevice}?SiteId=${siteId}&Device=${checkedValue}`,
    headers: {
      Authorization: `Bearer ${accessToken}`
    }
  };
  return axios(Object)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      message.info(err && err.response && err.response.data && err.response.data.message);
    });
}
export async function getAnalysisList(activeTab) {
  const accessToken = localStorage.get('accessToken');
  const siteId = localStorage.get('currentSite');
  const Object = {
    method: 'GET',
    url: `${API_FRACAS_MULTIPLE.FracasReportAnalysisGet}?SiteId=${siteId}&ScreenName=${activeTab}`,
    headers: {
      Authorization: `Bearer ${accessToken}`
    }
  };
  return axios(Object)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      message.info(err && err.response && err.response.data && err.response.data.message);
    });
}
export async function getAnalysisByIdMultiple(Id) {
  const accessToken = localStorage.get('accessToken');
  const siteId = localStorage.get('currentSite');
  const Object = {
    method: 'GET',
    url: `${API_FRACAS_MULTIPLE.AnalysisGet}?ReportId=${Id}&SiteId=${siteId}`,
    headers: {
      Authorization: `Bearer ${accessToken}`
    }
  };
  return axios(Object)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      message.info(err && err.response && err.response.data && err.response.data.message);
    });
}
export async function getAllAnalysisById(reportId) {
  const token = localStorage.get('accessToken');
  var Authorization = 'Bearer ' + token;
  const siteId = localStorage.get('currentSite');
  let data = {
    url: `${API_FRACAS_MULTIPLE.AnalysisGetById}?SiteId=${siteId}&ReportId=${reportId}`,
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: Authorization
    }
  };
  return axios(data)
    .then((response) => {
      return response.data;
    })

    .catch(() => { });
}
export async function getCorrectiveByIdMultiple(Id) {
  const accessToken = localStorage.get('accessToken');
  const siteId = localStorage.get('currentSite');
  const Object = {
    method: 'GET',
    url: `${API_FRACAS_MULTIPLE.CorrectiveActionGet}?ReportId=${Id}&SiteId=${siteId}`,
    headers: {
      Authorization: `Bearer ${accessToken}`
    }
  };
  return axios(Object)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      message.info(err && err.response && err.response.data && err.response.data.message);
    });
}
export async function getHistoryList(department, screen) {
  const accessToken = localStorage.get('accessToken');
  const siteId = localStorage.get('currentSite');
  const Object = {
    method: 'GET',
    url: `${API_FRACAS_MULTIPLE.GetByDepartmentId}?SiteId=${siteId}&DepartmentId=${department}&ScreenName=${screen}`,
    headers: {
      Authorization: `Bearer ${accessToken}`
    }
  };
  return axios(Object)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      message.info(err && err.response && err.response.data && err.response.data.message);
    });
}

